const ja = {
  download: "請求レポートをダウンロードする",
  filter: {
    webSite: "Webサイト",
    all: "全て",
    groupName: "グループ",
    transactionId: "取引番号",
    orderId: "サイト注文番号",
    date: "期間",
    selectDate: "日付を選択してください",
    quicklySelect: {
      lab: "クイック選択",
      range: {
        today: "今日",
        lastWeek: "先週",
        lastMonth: "先月",
        lastYear: "去年"
      }
    }
  },
  tableColumns: {
    settlementTime: "決済日時",
    transactionTime: "取引日時",
    transactionComTime: "取引完了時間",
    transactionID: "取引番号",
    orderId: "サイト注文番号",
    gatewayFlowID: "ゲートウェイのシリアル番号",
    website: "Webサイト",
    groupName: "グループ",
    currency: "取引通貨",
    amount: "取引金額",
    refundAmount: "返金額",
    settlementCurrency: "決済通貨",
    settlementExchangeRate: "決済為替レート",
    settlementAmount: "決済金額",
    deposit: "マージン",
    transactionFee: "取引手数料",
    refundFee: "返金手数料"
  },
  detail: {
    title: "取引照会",
    refundTitle: "返金照会",
    group: "グループ",
    store: "店",
    storeName: "Webサイト",
    omniWebsiteStore: "ウェブサイト・店舗",
    status: "取引状況",
    refundStatus: "返金状況",
    time: "取引日時",
    refundTime: "返金日時",
    startTime: "開始時間",
    endTime: "終了時間",
    orderId: "サイト注文番号",
    omniOrderId: "販売者の注文番号",
    refundOrderId: "サイト返金番号",
    omniRefundOrderId: "販売者返金シリアル番号",
    originTransactionId: "元の取引注文番号",
    merchantTransactionId: "サイト注文番号",
    omniMerchantTransactionId: "販売者の注文番号",
    transactionID: "取引番号",
    shopifyOrderId: "Shopify注文番号",
    refundTransactionID: "返金番号",
    search: "検索",
    clear: "リセット",
    detail: "詳細",
    enabled: '成功',
    disabled: "失敗",
    export: "結果のエクスポート",
    advancedFilter: "詳細条件",
    orderIdTransactionID: "サイト注文番号 / 取引番号",
    omniOrderIdTransactionID: "販売者の注文番号/トランザクションのシリアル番号",
    orderIdRefundID: "サイト返金番号 / 返金番号",
    omniOrderIdRefundID: "販売者返金シリアル番号/返金シリアル番号",
    consumer: "メールアドレス/携帯電話番号",
    groupStore: "Webサイト / グループ",
    omniGroupStore: "店舗/ウェブサイト/グループ",
    outFlowId: "取引番号",
    transactionId: "取引注文番号",
    transactionMode: "取引モデル",
    cardNo: "非感作カード番号",
    cardTipText: "非感作カード番号は、カード番号の最初の 6 桁と最後の 4 桁による取引照会のみをサポートします。",
    cardNoError: "問い合わせるカード番号の最初の6桁と最後の4桁を入力してください。"
  },
  invoice: {
    invoice: "毎月の請求書",
    desc: "毎月1日に前月の請求書を発行させていただきます。",
    pickerMonth: "月を選択してください",
    fileName: "ファイル名",
    month: "月",
    operator: "操作",
    download: "ダウンロード",
    create: "ファイルが生成されています",
    fail: "ファイル生成に失敗しました"
  },
  statementDownload: {
    statementDownload: "明細書のダウンロード",
    time: "決済時間：",
    omniTime: "取引日:",
    startTime: "開始時間",
    endTime: "終了時間",
    fileName: "ファイル名",
    type: "タイプ",
    tableTime: "決済日時",
    omniTableTime: "取引日",
    omniSettlementDate: "決済日",
    action: "操作",
    bill: "声明",
    date: "日次明細",
    week: "週次明細",
    month: "月次明細",
    custom: "カスタム明細",
    confirm: "ダウンロードの生成",
    transactionReport: "取引明細書",
    settlementReport: "資金明細書",
    disputeReport: "紛争声明",
    customReport: "カスタム明細",
    useTemplate: "テンプレートを使用する",
    batchDownload: "一括ダウンロード",
    tip1: "選択した日付に対応する明細書はすでに生成されています。再度生成しないでください。",
    tip2: "%{date} のステートメントが生成されています。しばらくお待ちください。"
  },
  statementSetting: {
    title: "明細設定",
    fieldSetting: "ステートメントフィールドの設定",
    getMethod: "声明を取得する方法:",
    ppCheckout: "販売者のバックエンド",
    sftp: 'PingPong SFTP',
    directory: "カタログダウンロード",
    tip: "SFTP を選択する場合は必須です。テクニカル サポートに連絡して、ダウンロード ディレクトリを追加し、ここで構成してください。",
    validTip: "SFTP ダウンロード ディレクトリを入力してください",
    format: "ステートメントの形式:",
    rate: "ステートメント生成の頻度:",
    date: '日',
    week: "週",
    month: '月',
    templateName: "テンプレート名",
    delTemplate: "テンプレートの削除",
    fieldName: "フィールド名",
    customTemplate: "カスタマイズされたステートメントテンプレート",
    delTip: "「%{title}」を削除してもよろしいですか?",
    delTitle: "ステートメントテンプレートの削除",
    delConfirm: "確認",
    delCancel: "キャンセル",
    delSuccsee: "削除が成功しました!",
    delCanceled: "削除を取り消す",
    save: "設定を保存する",
    cancel: "変更をキャンセルする"
  }
};
export default ja;
